import Api from '../api';

const { axios: api } = Api;

export const registerAgeConsent = async (browserId) => {
	const { data } = await api.post('/age-consent', { browserId });
	return data;
};
